// import BionicLogo from '../BionicUI/bionicLogo/BionicLogo';
import { cn } from '../../lib/utils';

const LogoBarStatic = () => {
  return (
    <div
      id="logo-container"
      className={cn(
        'grid w-full h-full justify-center',
        'relative items-start'
      )}
    >
      <img
        src="/images/ground-zero-logo.svg"
        alt=""
        className="h-[42px] w-[174px] object-none"
      />
      {/* <BionicLogo className={'w-[10vw] min-w-[150px]'} animate={true} /> */}
    </div>
  );
};

export default LogoBarStatic;
